import { SignOutResponse } from "@amzn/ermine-ssr-sdk/clients/ermineserversiderenderingservice";
import { AWSError } from "aws-sdk";
import log from "../../logging";
import { useMutation } from "@tanstack/react-query";
import { getErmineSsrClient } from "../../utils/ermineSsrClientUtil";
import {
    getFormattedAwsErrorMessage,
    isAWSError,
} from "../../utils/errorUtils";

export const useSignOut = () => {
    const result = useMutation<SignOutResponse, AWSError>({
        mutationFn: async () => {
            try {
                return await getErmineSsrClient()
                    .makeUnauthenticatedRequest("signOut", {})
                    .promise();
            } catch (err) {
                await log.error(
                    isAWSError(err)
                        ? getFormattedAwsErrorMessage(err, "SSOSignOut")
                        : "Failed to sign out"
                );
                throw err;
            }
        },
    });

    return result.mutateAsync;
};
